import KM from '@ott/utility-km';

import { getDeviceType } from '../getDeviceType';
import { shouldLogEvents } from './shouldLogEvents';

type EventSenderParams = { name: string; params?: Record<string, unknown>; time?: Date };

type EventSenderFunction = (params: EventSenderParams) => void;

export const km: EventSenderFunction = ({ name, params = {}, time = new Date() }) => {
  const baseParams = {
    isAdaptive: getDeviceType() === 'mobile',
  };

  try {
    const callArgs: Parameters<typeof KM> = [
      name,
      {
        time,
        obj: {
          ...baseParams,
          ...params,
        },
      },
    ];

    if (shouldLogEvents()) {
      console.log('km-event--->', ...callArgs); // eslint-disable-line no-console
    } else {
      KM(...callArgs);
    }
  } catch (error) {
    if (error instanceof Error) {
      error.message = `[KM_ERROR]: Не удалось отправить событие ${name}! ${error.message}`;
    }
  }
};
